import {Component,ElementRef,EventEmitter,Inject,Input,OnChanges,OnDestroy,OnInit,Output,Renderer2} from '@angular/core';
import {animate,group,state,style,transition,trigger} from '@angular/animations';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'basic-dialog',
  styleUrls: ['./dialog.component.scss'],
  templateUrl: './dialog.component.html',
  animations: [
    trigger('dialogState', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('1000ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('1000ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class BasicDialogComponent implements OnChanges, OnDestroy {
  @Input() visible = false;
  @Input() modalId = '';
  // @Input() styles: any;
  @Input() modalStyles: any;
  @Input() dialogStyles: any;

  constructor(private renderer: Renderer2, private element: ElementRef) { }

  ngOnChanges(): void {
    if (this.visible) {
      this.element.nativeElement.querySelector('.modal').id = this.modalId;
      document.querySelector('body')?.appendChild(this.element.nativeElement);

      this.element.nativeElement
        .querySelector(`#${this.modalId}`)
        .classList.add('in');

      document.querySelector('body')?.classList.add('modal-open');
    }
  }
  ngOnDestroy(): void {
    if (
      this.element.nativeElement.parentElement &&
      this.element.nativeElement.parentElement.tagName &&
      this.element.nativeElement.parentElement.tagName.toUpperCase() ===
      'body'.toUpperCase()
    )
      document.querySelector('body')?.removeChild(this.element.nativeElement);
    document.querySelector('body')?.classList.remove('modal-open');
  }
}
